import React, {useRef} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Category from '@mui/icons-material/Category';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Progress from '../components/Loader';
// import Box from '@mui/material/Box';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Logo from "../assets/playstore.png"
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EngineeringIcon from '@mui/icons-material/Engineering';
// import CameraAltIcon from '@mui/icons-material/CameraAltIcon';
import axios from 'axios';
import InputAdornment from '@mui/material/InputAdornment';
import ReactToPrint from 'react-to-print';
import Tablemain from "./editabletable"
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Badge from '@mui/material/Badge';
// import CameraAltIcon from '@mui/material/CameraAltIcon';
import Avatar from '@mui/material/Avatar';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getcustomer } from '../redux/customer';
import { getcommodity } from '../redux/commodity';
import { getexpenses } from '../redux/expenses';
import { getfarmer } from '../redux/farmer';
import { gethauller } from '../redux/hauller';
import { getprocessingcenter } from '../redux/processingcenter';
import { getproduct } from '../redux/product';
import { getrequisition } from '../redux/requisition';
import { getsales } from '../redux/sales';
import { getservice } from '../redux/service';
import { getstaff } from '../redux/staff';
import { getcontract } from '../redux/contract';
import { getwarehouse } from '../redux/warehouse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {

  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  const dispatch = useDispatch()
  const [productpro, setproductpro] = React.useState([]);

  const [warehousetype, setwarehousetype] = React.useState(props.chosen.warehousetype?props.chosen.warehousetype:"");
  const [marrital, setmarrital] = React.useState(props.chosen.marrital?props.chosen.marrital:"");
  const [position, setposition] = React.useState(props.chosen.position?props.chosen.position:"");
  const [ownershiptype, setownershiptype] = React.useState(props.chosen.ownershiptype?props.chosen.ownershiptype:"");
  const [cultivatingmethod, setcultivatingmethod] = React.useState(props.chosen.cultivatingmethod?props.chosen.cultivatingmethod:"");
  const [croptype, setcroptype] = React.useState(props.chosen.croptype?props.chosen.croptype:"");
  const [seed, setseed] = React.useState(props.chosen.seed?props.chosen.seed:"");
  const [fertilizer, setfertilizer] = React.useState(props.chosen.fertilizer?props.chosen.fertilizer:"");
  const [water, setwater] = React.useState(props.chosen.water?props.chosen.water:"");
  const [capacity, setcapacity] = React.useState(props.chosen.capacity?props.chosen.capacity:"");
  const [centertype, setcentertype] = React.useState(props.chosen.centertype?props.chosen.centertype:"");
 
  const [businesstype, setbusinesstype] = React.useState(props.chosen.businesstype?props.chosen.businesstype:"");
  const [gender, setgender] = React.useState(props.chosen.gender?props.chosen.gender:"");
  const [personName, setPersonName] = React.useState([]);
  const [open, setOpen] = React.useState(props.value);

//   const [open, setOpen] = React.useState(false);
const [category, setcategory] = React.useState("none");
const [center_, setcenter_] = React.useState("none");
const [loading, setloading] = React.useState(false);
const handleOpen = () => setOpen(true);
const [unit, setunit] = React.useState(props.chosen.unit?props.chosen.unit:"");
const [currentbatch, setcurrentbatch] = React.useState("");
const [inputlist, setinputlist] = React.useState(props.chosen.inputlist?props.chosen.inputlist:"");
const [payment, setpayment] = React.useState(props.chosen.payment?props.chosen.payment:""); 
const [disability, setdisability] = React.useState(props.chosen.disability?props.chosen.disability:"");
const [person, setperson] = React.useState(props.chosen.person?props.chosen.person:"")
const [farmer, setfarmer] = React.useState(props.chosen.farmer?props.chosen.farmer:[]);
const [multicrops, setmulticrops] = React.useState(props.chosen.multicrops?props.chosen.multicrops:[]);
const admin = useSelector((state) => state.admin)
const farmer_ = useSelector((state) => state.farmer)
const product_ = useSelector((state) => state.product)
const customer_ = useSelector((state) => state.customer)
const staff_ = useSelector((state) => state.staff)
const sales = useSelector((state) => state.sales)
const agent = useSelector((state) => state.hauler)
const warehouse_ = useSelector((state) => state.warehouse)
const service_ = useSelector((state) => state.service)
const center = useSelector((state) => state.center)
const commodity_ = useSelector((state) => state.commodity)
const [vehicle, setvehicle] = React.useState([]);
const [haulliagetype, sethaulliagetype] = React.useState(props.chosen.haulliagetype?props.chosen.haulliagetype:"");
const [employmenttype, setemploymenttype] = React.useState(props.chosen.employmenttype?props.chosen.employmenttype:"");
const [iniposition, setiniposition] = React.useState(props.chosen.iniposition?props.chosen.iniposition:"");
const componentRefinvoice = useRef()
const componentRefwaybill = useRef()
const componentRefpurchase = useRef()
const componentRefload = useRef()





  const [customertype, setcustomertype] = React.useState(props.chosen.customertype?props.chosen.customertype:"");
  const [productservice, setproductservice] = React.useState("none");
 const [haullier, sethaullier] = React.useState(props.chosen.haullier?props.chosen.haullier:"");
  const [chosenhaullier, setchosenhaullier] = React.useState(props.chosen.haullier?props.chosen.haullier:[]);
  const [method, setmethod] = React.useState("none");
  const [drivername, setdrivername] = React.useState(props.chosen.driver?props.chosen.driver:"");
  const [drivercontact, setdrivercontact] = React.useState("none");
  const [vehicleregistration, setvehicleregistration] = React.useState(props.chosen.registration?props.chosen.registration:"");
 
  const haullier_ = useSelector((state) => state.hauler)
 

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleClose=()=>{
    setOpen(false);
    props.setfalser()
    }

const commodity=()=>{
  // set gender, unit, personName
setgender(props.chosen.agent)
setunit(props.chosen.unit)
setPersonName(props.chosen.product)


  const names = [

    "Maize",
    "Soya Beans",
    "Onion",
    "Pepper",
    "Tomatoes"

  ];


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };


  const addcustomer= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/students/discount/",
            {
              
                batch: document.getElementById("batch").value,
                agent: gender,
                amountgiven: document.getElementById("amount").value,
                expecteddate: document.getElementById("expecteddate").value,
                qty: document.getElementById("qty").value,
                prefinancedate: document.getElementById("prefinancedate").value,
                others: document.getElementById("others").value,
                unit: unit,
                product: personName,

            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false)  
                    dispatch(getcommodity({

                      data: res.data

                  }))
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}


return (
  <div>
   
   
    <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>Pre-Finance</Button>
   
 


<Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
         Pre-Finance
   
     <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
    
 </DialogTitle>
 <Divider/>
<DialogContent>

      
        <Box
    component="form"
    sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
    noValidate
    autoComplete="off"
  >
     <TextField
        id="batch"
        label="Batch Number"
        type="text"
        defaultValue={props.chosen.batch}
        value={currentbatch}
        disabled
        autoComplete="current-text"
       
      />
             
      <TextField
        id="outlined-select-currency-native"
        select
        label="Choose Agent"
        value={gender}
        onChange={(e)=>setgender(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
      
          <option key="none" value="none">Choose  Agent</option>
{agent.map((list, i)=>
          <option key={list.haullier} value={list.haullier}> {list.haullier}  </option>

)

}{staff.map((list, i)=>
          <option key={list.lastname+" "+list.othername+" "+list.firstname} value={list.lastname+" "+list.othername+" "+list.firstname}> {list.lastname+" "+list.othername+" "+list.firstname}  </option>

)

}      
      </TextField>

     

      <TextField
        id="amount"
        label="Amount Given"
        defaultValue={props.chosen.amountgiven}
        type="number"
        autoComplete="current-text"
        InputProps={{
          startAdornment: <InputAdornment position="start">GHC</InputAdornment>,
        }}
      />  
        
        <TextField
        id="expectdate"
        label="Expected Supply Date"
        type="date"
        defaultValue={props.chosen.expecteddate}
        autoComplete="current-text"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
        }}
      />   
      <TextField
        id="qty"
        defaultValue={props.chosen.qty}
        label="Quantity of Pre-finance"
        type="number"
        autoComplete="current-text"
       
      /> 
        <TextField
        id="outlined-select-currency-native"
        select
        label="Unit Of Measurement"
        value={unit}
        onChange={(e)=>setunit(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
      
          <option key="none" value="none">Choose</option>
          <option key="Kg" value="Kg">Kg</option>
          <option key="bags" value="bags">bags</option>
          <option key="tons" value="tons">tons</option>
    
      </TextField>

      <FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Choose Products</InputLabel>
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        // id="outlined-select-currency-native"
        // label="Equipment"
        value={personName}
        onChange={handleChange}
        input={<OutlinedInput label="Choose Products" />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={MenuProps}
      >
        {names.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={personName.includes(name)} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>

      </FormControl>

     
        
  
<TextField
        id="prefinancedate"
        label="Date Pre-financed"
       type="date"
       defaultValue={props.chosen.prefinancedate}
       InputProps={{
        startAdornment: <InputAdornment position="start"></InputAdornment>,
      }}
      />
        
  
<TextField
        id="others"
        defaultValue={props.chosen.others}
        label="Other Information"
        multiline
        rows={4}
      />


        
      </Box>




</DialogContent>
<Divider/>
 <DialogActions>






<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
          { loading?<Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
           :<Button  variant="outlined" startIcon={<Category />} size={"large"} onClick={addcustomer}>Submit</Button>
      }
           </div>

     
 </DialogActions>
</Dialog>


</div>



);

}


const contract = ()=>{

  setfarmer(props.chosen.farmer)
  setinputlist(props.chosen.inputlist)
  setpayment(props.chosen.payment)


  const Food=[
    {value:"Cereals"},
    {value: "Industrial crops"}, 
    {value:"Legumes"},
    {value:"Fruits"},
    {value:"Vegetables"},
    {value:"Starchy"},
    {value:"tuber"},
    {value: "root crops"}
  ]
 

  


  // functions

  const addfarmer= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/requisition/addrequisition/",
            {
                farmername: document.getElementById("farmername").value,
                farmer: farmer,
                inputlist: inputlist,
                quantity: document.getElementById("quantity").value,
                unit: document.getElementById("unit").value,
                expected: document.getElementById("expected").value,
                actual: document.getElementById("actual").value,
                yieldunit: document.getElementById("yieldunit").value,
                paymenttype: payment,
                amount: document.getElementById("amount").value,
                qtyBarter: document.getElementById("qty").value,
                unitBarter: document.getElementById("unitBarter").value,
                paymentterms: document.getElementById("paymentterms").value,

               
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false)  
                    dispatch(getcontract({

                      data: res.data

                  }))
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}

const names = [

  "Maize",
  "Soya Beans",
  "Onion",
  "Pepper",
  "Tomatoes",
  "Rice"

];


 
return (
  <div>
   
   
    <Button variant="outlined"  onClick={handleOpen}>Edit Contract</Button>
    
    <Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
          Edit Contract
    
      <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
     
  </DialogTitle>


  <Divider/>

<DialogContent>

        <Box
    component="form"
    sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
    noValidate
    autoComplete="off"
  >
       
      
      <TextField
        id="outlined-select-currency-native"
        select
        label="Choose Farmer"
        // defaultValue="Gender"
        value={farmer}
        onChange={(e)=>setfarmer(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
        
          <option key="none" value="none">Choose</option>
          {
            farmer_.map((list,i)=>
              <option key={list.farmername} value={list.farmername}>{list.farmername}</option>
            )
          }
      </TextField>
      <TextField
        id="farmername"
        label="Farmer Name"
        defaultValue={props.chosen.farmername}
        type="text"
        helperText="If new farmer, enter Name"
        autoComplete="current-text"
      />

      <TextField
        id="outlined-select-currency-native"
        select
        label="Input Requested"
        // defaultValue="Gender"
        value={inputlist}
        onChange={(e)=>setinputlist(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
        
          <option key="none" value="none">Choose Service</option>
          {
            service.map((list,i)=>
              <option key={list.farmername} value={list.farmername}>{list.farmername}</option>
            )
          }
      
      </TextField>
      

      <TextField
        id="quantity"
        label="Quantity"
        defaultValue={props.chosen.quantity}
        type="number"
        autoComplete="current-text"
      /> 
      <TextField
        id="unit"
        defaultValue={props.chosen.unit}
        label="Unit"
        type="text"
        autoComplete="current-text"
      />  

<TextField
        id="expected"
        label="Expected Yield"
        defaultValue={props.chosen.expected}
        type="text"
        autoComplete="current-text"
      /> 
    
<TextField
        id="actual"
        label="Actual Yield"
        defaultValue={props.chosen.actual}
        type="text"
        autoComplete="current-text"
      /> 
       <TextField
        id="yieldunit"
        defaultValue={props.chosen.yieldunit}
        label="Yield Unit"
        type="text"
        autoComplete="current-text"
      /> 

        <TextField
        id="outlined-select-currency-native"
        select
        label="Payment terms"
        // defaultValue="Gender"
        value={payment}
        onChange={(e)=>setpayment(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
        
          <option key="none" value="none">Choose Service</option>
          <option key="Cash" value="Cash">Cash</option>
          <option key="Barter" value="Barter">Barter</option>
      
      </TextField> 
    {payment==="Cash" ?
     <TextField
     id="amount"
     label="Amount"
     defaultValue={props.chosen.amount}
     type="text"
     InputProps={{
      startAdornment: <InputAdornment position="start">GHC</InputAdornment>,
    }}
     autoComplete="current-text"
   /> :
   <>
   <TextField
   id="qty"
   label="Quantity"
   defaultValue={props.chosen.qtyBarter}
   type="text"
   autoComplete="current-text"
 />
 <TextField
   id="unitBarter"
   defaultValue={props.chosen.unitBarter}
   label="Unit"
   type="text"
   autoComplete="current-text"
 />
 </>
    }
      <TextField
        id="paymentterms"
        defaultValue={props.chosen.paymentterms}
        label="Payment terms"
        type="text"
        autoComplete="current-text"
      />  
        
      </Box>



</DialogContent>
<Divider/>
  <DialogActions>


<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
           { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
           : <Button  variant="outlined"  size={"large"} onClick={addfarmer}>Submit New Farmer</Button>
      }
      </div>

      
  </DialogActions>
</Dialog>









  </div>
);
}

const product=()=>{

  setcategory(props.chosen.category)
  
  const Food=[
   "Maize",
  "Soya Beans",
  "Onion",
  "Pepper",
  "Tomatoes",
  "Rice"
  ]




  const addproduct= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/product/editproduct/",
            {
              
                productname: document.getElementById("productname").value,
                category: category,
                bestplant: document.getElementById("bestplant").value,
                bestharvest: document.getElementById("bestharvest").value,
                nutrition: document.getElementById("nutrition").value,
                description: document.getElementById("description").value,
                condition: document.getElementById("condition").value,

            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false)
                    dispatch(getproduct({

                      data: res.data

                  }))  
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}




    return(
    <>
    
   
    <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          <TextField
          id="productname"
          label="Product Name"
          defaultValue={props.chosen.productname}
          type="text"
          autoComplete="current-text"
        />  
        
        <TextField
          id="outlined-select-currency-native"
          select
          label="Category"
          value={category}
          onChange={(e)=>setcategory(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
          {Food.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </TextField>

        <TextField
          id="bestplant"
          defaultValue={props.chosen.bestplant}
          label="Best Season for planting"
          type="text"
          autoComplete="current-text"
        />  
          
          <TextField
          id="bestharvest"
          defaultValue={props.chosen.bestharvest}
          label="Best Season for harvest"
          type="text"
          autoComplete="current-text"
        />  
          
         <TextField
          id="nutrition"
          defaultValue={props.chosen.nutrition}
          label="Nutritional Info"
          multiline
          rows={4}
        />   
         <TextField
          id="description"
          defaultValue={props.chosen.description}
          label="Product Description"
          multiline
          rows={4}
        />
<TextField
          id="condition"
          defaultValue={props.chosen.condition}
          label="Optimum Storage Condition"
          multiline
          rows={4}
        />


          
        </Box>

        <div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
           { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
           : <Button  variant="outlined"  size={"large"} onClick={addproduct}>Submit New Farmer</Button>
      }
      </div>
    
    </>
  
  
  
    )
}


const customermain=()=>{


  const addcustomer= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/students/discount/",
            {
              
                businessname: document.getElementById("businessname").value,
                gender: gender,
                contact: document.getElementById("contact").value,
                address: document.getElementById("address").value,
                principal: document.getElementById("principal").value,
                days: document.getElementById("days").value,
                businesstype: businesstype,
                payment: payment,
                Interest: personName,
                others: document.getElementById("others").value,

            }).then(res=>{

                if (res.status === 200) {
                
                    setloading(false)  
                    dispatch(getcustomer({

                      data: res.data

                  }))
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}

const names = [

  "Crops",
  "Seeds",
  "Fertilizers",
  "Machinery",
  "Irrigation"

];



return (
  <div>
   
   
    <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>Add Customer</Button>
   
 


<Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
         Add new Customer
   
     <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
    
 </DialogTitle>
 <Divider/>
<DialogContent>

      
        <Box
    component="form"
    sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
    noValidate
    autoComplete="off"
  >
        <TextField
        id="businessname"
        label="Business Name"
        type="text"
        autoComplete="current-text"
      />  
      
      <TextField
        id="outlined-select-currency-native"
        select
        label="Gender"
        value={gender}
        onChange={(e)=>setgender(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
      
          <option key="none" value="none">Choose  </option>
          <option key="Male" value="Male">Male  </option>
          <option key="Female" value="Female">Female  </option>
          <option key="Co-operate" value="Co-operate">Co-operate  </option>
    
      </TextField> 


      <TextField
        id="contact"
        label="Contact"
        type="tel"
        autoComplete="current-text"
      />  
        
        <TextField
        id="address"
        label="address"
        type="address"
        autoComplete="current-text"
      />   
        <TextField
        id="principal"
        label="Principal Agent Name"
        type="text"
        autoComplete="current-text"
      />  

<TextField
        id="outlined-select-currency-native"
        select
        label="Business Type"
        value={businesstype}
        onChange={(e)=>setbusinesstype(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
       
          <option key="none" value="none">Choose  </option>
          <option key="Retailer" value="Retailer">Retailer  </option>
          <option key="Wholesaler" value="Wholesaler">Wholesaler  </option>
          <option key="Farmer" value="Farmer">Farmer  </option>
          <option key="Food Processing" value="Food Processing">Food Processing  </option>
          <option key="Agent" value="Agent">Agent  </option>
    
      </TextField> 
        <TextField
        id="outlined-select-currency-native"
        select
        label="Payment Terms"
        value={payment}
        onChange={(e)=>setpayment(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
       
          <option key="none" value="none">Choose  </option>
          <option key="Cash" value="Cash">Cash  </option>
          <option key="Credit" value="Credit">Credit  </option>
    
      </TextField> 
     {  payment==="Credit"&& 
      <TextField
        id="days"
        label="Allowed Days"
        type="text"
        autoComplete="current-text"
      /> 
     }


      <FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">  Market and Product Interests</InputLabel>
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        // id="outlined-select-currency-native"
        // label="Equipment"
        value={personName}
        onChange={handleChange}
        input={<OutlinedInput label="  Market and Product Interests" />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={MenuProps}
      >
        {names.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={personName.includes(name)} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>

      </FormControl>
        
  
<TextField
        id="others"
        label="Other Information"
        multiline
        rows={4}
      />


        
      </Box>




</DialogContent>
<Divider/>
 <DialogActions>






<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
          { loading?<Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
           :<Button  variant="outlined" startIcon={<Category />} size={"large"} onClick={addcustomer}>Submit New Customer</Button>
      }
           </div>

     
 </DialogActions>
</Dialog>


</div>



);





}


const farmermain=()=>{
  

  const addfarmer= () =>{
    setloading(true)
    const file = document.getElementById("fileimage").files[0]
    const image = ""
      
    const fd = new FormData()
                   
                    if (file) {
                   
                        fd.append("file", file)
                        fd.append("image", document.getElementById("fileimage").files[0].name)
                    }

                    fd.append("farmername", document.getElementById("farmername").value)
                    fd.append("contact", document.getElementById("contact").value)
                    fd.append("gender", gender)
                    fd.append("disability", disability)
                    fd.append("dob", document.getElementById("dob").value)
                    fd.append("idnumber", document.getElementById("idnumber").value)
                    fd.append("address", document.getElementById("address").value)
                    fd.append("community", document.getElementById("community").value)
                    fd.append("district", document.getElementById("district").value)
                    fd.append("region", document.getElementById("region").value)
                    fd.append("gpslocation", document.getElementById("gpslocation").value)
                    fd.append("estimatedfarmsize", document.getElementById("estimatedfarmsize").value)
                    fd.append("actualfarmsize", document.getElementById("actualfarmsize").value)
                    fd.append("ownershiptype", ownershiptype)
                    fd.append("croptype", personName)
                    fd.append("cultivatingmethod", cultivatingmethod)
                    fd.append("watter", water)
                    fd.append("acreage", document.getElementById("acreage").value)
                    fd.append("machinery", document.getElementById("machinery").value)
                    fd.append("others", document.getElementById("others").value,              )
    
    
    
    const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/farmer/editfarmer/",fd, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log("farmer res")
                    console.log(res)
                    dispatch(getfarmer({

                      data: res.data

                  })) 
                  handleClose()
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

}


const names = [

  "Maize",
  "Soya Beans",
  "Onion",
  "Pepper",
  "Tomatoes",
  "Rice"

];

const imagehandler = (e) => {
  const reader = new FileReader()
  reader.onload = () => {
      if (reader.readyState === 2) {
          setperson(reader.result)
      }
  }

  reader.readAsDataURL(e.target.files[0])
}


return (
  <div>
   
   
    <Button variant="outlined" onClick={handleOpen}>Add Farmer</Button>
    


    <Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
          Add new Farmer
    
      <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
     
  </DialogTitle>



  <Divider/>

<DialogContent>

        <Box
         component="form"
         sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
         noValidate
         autoComplete="off"
       >
         <div style={{ width: "100%", textAlign:"center", marginBottom:"20px" }}>
   
   
   
                               <input
   
                                   style={{ display: "none" }}
                                   id="fileimage"
                                   multiple
                                   type="file"
                                   onChange={(e) => imagehandler(e)}
                               />
                               <label htmlFor="fileimage">
                                   <Badge
                                       overlap="circular"
                                       anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                       badgeContent={
                                           <CameraAltIcon style={{ cursor:"pointer", backgroundColor: "darkblue", padding: 6, borderRadius: "100%", color: "white", fontSize: "26px" }} />
                                       }
                                   >
                                       <Avatar style={{ width: 100, height: 100, border: "solid", borderColor: "#f0f0f0" }} alt="Travis Howard" src={person} />
   
                                   </Badge>
   
                               </label>
   
                              
                           </div>
             <TextField
             id="farmername"
             label="Farmer Name"
             type="text"
             defaultValue={props.chosen.farmername?props.chosen.farmername:""}
             autoComplete="current-text"
           />  
           
           <TextField
             id="outlined-select-currency-native"
             select
             label="Gender"
             // defaultValue="Gender"
             value={gender}
             onChange={(e)=>setgender(e.target.value)}
             slotProps={{
               select: {
                 native: true,
               },
             }}
           //   helperText="Please select category"
           >
             
               <option key="none" value="none">Choose</option>
               <option key="Male" value="Male">Male</option>
               <option key="Female" value="Female">Female </option>
           
           </TextField>
             
           <TextField
             id="outlined-select-currency-native"
             select
             label="Disability Status"
             // defaultValue="Gender"
             value={disability}
             onChange={(e)=>setdisability(e.target.value)}
             slotProps={{
               select: {
                 native: true,
               },
             }}
           //   helperText="Please select category"
           >
             
               <option key="none" value="none">Choose</option>
               <option key="Yes" value="Yes">Yes</option>
               <option key="No" value="No">No </option>
           
           </TextField>
           
   
           <TextField
             id="dob"
             label="Date Of Birth"
             type="date"
             defaultValue={props.chosen.dob?props.chosen.dob:""}

             // defaultValue={}
             autoComplete="current-text"
             InputProps={{
               startAdornment: <InputAdornment position="start"> </InputAdornment>,
             }}
           /> 
           <TextField
             id="contact"
             label="Contact"
             type="tel"
             defaultValue={props.chosen.contact?props.chosen.contact:""}

             autoComplete="current-text"
           /> 
           <TextField
             id="idnumber"
             label="ID Number"
             type="text"
             defaultValue={props.chosen.idnumber?props.chosen.idnumber:""}

             autoComplete="current-text"
           />  
   
           <TextField
             id="address"
             label="Address"
             type="tel"
             defaultValue={props.chosen.address?props.chosen.address:""}

             autoComplete="current-text"
           /> 
           <TextField
             id="community"
             label="Community"
             type="text"
             defaultValue={props.chosen.community?props.chosen.community:""}

             autoComplete="current-text"
           />  
           <TextField
             id="district"
             label="District"
             type="text"
             defaultValue={props.chosen.district?props.chosen.district:""}

             autoComplete="current-text"
           /> 
           <TextField
             id="region"
             label="Region"
             type="text"
             defaultValue={props.chosen.region?props.chosen.region:""}

             autoComplete="current-text"
           /> 
           <Divider/>
   
            
           <TextField
             id="gpslocation"
             label="Farm GPS Location"
             type="text"
             defaultValue={props.chosen.gpslocation?props.chosen.gpslocation:""}

             autoComplete="current-text"
           /> 
   
             <TextField
             id="estimatedfarmsize"
             label="Estimated Farm Size"
             type="number"
             defaultValue={props.chosen.estimatedfarmsize?props.chosen.estimatedfarmsize:""}

             autoComplete="current-text"
             InputProps={{
               endAdornment: <InputAdornment position="end">Acres</InputAdornment>,
             }}
           /> 
    <TextField
             id="actualfarmsize"
             label="Actual Farm Size"
             type="number"
             defaultValue={props.chosen.actualfarmsize?props.chosen.actualfarmsize:""}
             autoComplete="current-text"
             InputProps={{
               endAdornment: <InputAdornment position="end">Acres</InputAdornment>,
             }}
           /> 
   
           <TextField
             id="outlined-select-currency-native"
             select
             label="Ownership Type"
             // defaultValue="Ownership Type"
             value={ownershiptype}
             onChange={(e)=>setownershiptype(e.target.value)}
             slotProps={{
               select: {
                 native: true,
               },
             }}
           //   helperText="Please select category"
           >
               <option key="none" value="none">Choose</option>
               <option key="Owned" value="Owned">Owned</option>
               <option key="Leased" value="Leased">Leased</option>
               <option key="Co-operative" value="Co-operative">Co-operative</option>
           
           </TextField>
   
           <FormControl sx={{ m: 1, width: 225 }}>
   
   <InputLabel id="demo-multiple-checkbox-label">Crops Grown</InputLabel>
           <Select
             labelId="demo-multiple-checkbox-label"
             id="demo-multiple-checkbox"
             multiple
             // id="outlined-select-currency-native"
             // label="Equipment"
             value={personName}
             onChange={handleChange}
             input={<OutlinedInput label="Crops Grown" />}
             renderValue={(selected) => selected.join(', ')}
             MenuProps={MenuProps}
           >
             {names.map((name) => (
               <MenuItem key={name} value={name}>
                 <Checkbox checked={personName.includes(name)} />
                 <ListItemText primary={name} />
               </MenuItem>
             ))}
           </Select>
   
           </FormControl>
   
           
   <TextField
             id="outlined-select-currency-native"
             select
             label="Cultivating Method"
             // defaultValue="Cultivating Method"
             value={cultivatingmethod}
             onChange={(e)=>setcultivatingmethod(e.target.value)}
             slotProps={{
               select: {
                 native: true,
               },
             }}
           //   helperText="Please select category"
           >
              <option value="none">Choose</option>
                 <option value="Shifting Cultivation">Shifting Cultivation</option>
                 <option value="Subsistence Farming">Subsistence Farming</option>
                 <option value="Dryland Farming">Dryland Farming</option>
                 <option value="Monoculture Farming">Monoculture Farming</option>
                 <option value="Intensive Farming">Intensive Farming</option>
                 <option value="Irrigated Farming">Irrigated Farming</option>
                 <option value="Organic Farming">Organic Farming</option>
                 <option value="Conservation Tillage">Conservation Tillage</option>
                 <option value="Crop Rotation">Crop Rotation</option>
                 <option value="Vertical Farming">Vertical Farming</option>
                      
           </TextField>
   
           <TextField
             id="outlined-select-currency-native"
             select
             label="Water Usage"
             // defaultValue="Water Usage"
             value={water}
             onChange={(e)=>setwater(e.target.value)}
             slotProps={{
               select: {
                 native: true,
               },
             }}
           //   helperText="Please select category"
           >
               <option key="none" value="none">Choose</option>
               <option key="Irrigation" value="Irrigation">Irrigation</option>
               <option key="Rain Water" value="Rain Water">Rain Water</option>
               {/* <option key="Co-operative" value="Co-operative">Co-operative</option> */}
           
           </TextField>
             
             <TextField
             id="acreage"
             label="Acreage Supported"
             type="text"
             defaultValue={props.chosen.acreage?props.chosen.acreage:""}

             autoComplete="current-text"
           /> 
            <TextField
             id="machinery"
             label="Machinery / Equipments"
             multiline
             defaultValue={props.chosen.machinery?props.chosen.machinery:""}
             rows={4}
           />   
            <TextField
             id="others"
             label="Other Descriptions"
             multiline
             defaultValue={props.chosen.others?props.chosen.others:""}

             rows={4}
           />
   
   
             
           </Box>
    


</DialogContent>
<Divider/>
  <DialogActions>






<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
             : <Button  variant="outlined" startIcon={<EngineeringIcon />} size={"large"} onClick={addfarmer}>Edit Farmer</Button>
        }
        </div>

      
  </DialogActions>
</Dialog>









  </div>
);
}


const customer=()=>{

  

  const names = [

    "Crops",
    "Seeds",
    "Fertilizers",
    "Machinery",
    "Irrigation"

  ];


  

  const addcustomer= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/customer/editcustomer/",
            {
              
                businessname: document.getElementById("businessname").value,
                gender: gender,
                contact: document.getElementById("contact").value,
                address: document.getElementById("address").value,
                principal: document.getElementById("principal").value,
                days: document.getElementById("days").value,
                businesstype: businesstype,
                payment: payment,
                Interest: personName,
                others: document.getElementById("others").value,

            }).then(res=>{

                if (res.status === 200) {
                
                    setloading(false)  
                    dispatch(getcustomer({

                      data: res.data

                  }))
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}



    return(
         <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          <TextField
          id="businessname"
          label="Business Name"
          type="text"
          defaultValue={props.chosen.businessname?props.chosen.businessname:""}
          autoComplete="current-text"
        />  
        
        <TextField
          id="outlined-select-currency-native"
          select
          label="Gender"
          value={gender}
          onChange={(e)=>setgender(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
        
            <option key="none" value="none">Choose  </option>
            <option key="Male" value="Male">Male  </option>
            <option key="Female" value="Female">Female  </option>
            <option key="Co-operate" value="Co-operate">Co-operate  </option>
      
        </TextField> 


        <TextField
          id="contact"
          label="Contact"
          type="tel"
          defaultValue={props.chosen.contact?props.chosen.contact:""}

          autoComplete="current-text"
        />  
          
          <TextField
          id="address"
          label="address"
          type="address"
          defaultValue={props.chosen.address?props.chosen.address:""}

          autoComplete="current-text"
        />   
          <TextField
          id="principal"
          label="Principal Agent Name"
          type="text"
          defaultValue={props.chosen.principal?props.chosen.principal:""}

          autoComplete="current-text"
        />  

<TextField
          id="outlined-select-currency-native"
          select
          label="Business Type"
          value={businesstype}
          onChange={(e)=>setbusinesstype(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
         
            <option key="none" value="none">Choose  </option>
            <option key="Retailer" value="Retailer">Retailer  </option>
            <option key="Wholesaler" value="Wholesaler">Wholesaler  </option>
            <option key="Farmer" value="Farmer">Farmer  </option>
            <option key="Food Processing" value="Food Processing">Food Processing  </option>
            <option key="Agent" value="Agent">Agent  </option>
      
        </TextField> 
          <TextField
          id="outlined-select-currency-native"
          select
          label="Payment Terms"
          value={payment}
          onChange={(e)=>setpayment(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
         
            <option key="none" value="none">Choose  </option>
            <option key="Cash" value="Cash">Cash  </option>
            <option key="Credit" value="Credit">Credit  </option>
      
        </TextField> 
       {  payment==="Credit"&& 
        <TextField
          id="days"
          label="Allowed Days"
          type="text"
          autoComplete="current-text"
        /> 
       }

      <FormControl sx={{ m: 1, width: 225 }}>
<InputLabel id="demo-multiple-checkbox-label">  Market and Product Interests</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          // id="outlined-select-currency-native"
          // label="Equipment"
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="  Market and Product Interests" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={personName.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
        </FormControl>
              
<TextField
          id="others"
          label="Other Information"
          multiline
          defaultValue={props.chosen.others?props.chosen.others:""}
          rows={4}
        />

        <div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
                    { loading?<Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
                     :<Button variant="outlined" startIcon={<Category />} size={"large"} onClick={()=>addcustomer()}>Edit Customer</Button>
                }
                     </div>
        </Box>

  
    )
}



const dispatchmain=()=>{

  
setcenter_(props.chosen.center)

  // functions

  const names=[
    "Drying",
    "Cleaning",
    "Rebagging",
    "Standardization"
]

 
const addprocess= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/students/discount/",
            {
                processingcenter: center,
                processingtype: personName,
                rawqty: document.getElementById("rawqty").value,
                rawunit: document.getElementById("rawunit").value,
                finishedqty: document.getElementById("finishedqty").value,
                finishedunit: document.getElementById("finishedunit").value,
                processdate: document.getElementById("date").value,
                // others: document.getElementById("others").value,
               
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    dispatch(getcommodity({

                      data: res.data

                  })) 
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}


return(
          
  <Box
  component="form"
  sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
  noValidate
  autoComplete="off"
>

           
<TextField
      id="outlined-select-currency-native"
      select
      label="Processing Center"
      // defaultValue="Category"
      value={center_}
      onChange={(e)=>setcenter_(e.target.value)} 
      slotProps={{
        select: {
          native: true,
        },
      }}
    //   helperText="Please select category"
    >
        <option key="none" value="none"> Choose Center </option>
        {center_.map((list,i)=>
        <option key={list.servicename} value={list.servicename}>{list.servicename}</option>

)

  }           
    </TextField>

    <FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Processing Type</InputLabel>
    <Select
      labelId="demo-multiple-checkbox-label"
      id="demo-multiple-checkbox"
      multiple
      // id="outlined-select-currency-native"
      // label="Equipment"
      value={personName}
      onChange={handleChange}
      input={<OutlinedInput label="Processing Type" />}
      renderValue={(selected) => selected.join(', ')}
      MenuProps={MenuProps}
    >
      {names.map((name) => (
        <MenuItem key={name} value={name}>
          <Checkbox checked={personName.includes(name)} />
          <ListItemText primary={name} />
        </MenuItem>
      ))}
    </Select>

    </FormControl>

     
      <TextField
      id="rawqty"
      label="Raw Material Quantity"
      type="text"
      autoComplete="current-text"
    />  

<TextField
      id="rawunit"
      label="Unit"
      type="text"
      autoComplete="current-text"
    />
<TextField
      id="finishedqty"
      label="Finished Goods Quantity"
      type="text"
      autoComplete="current-text"
    />  

<TextField
      id="finishedunit"
      label="Unit"
      type="text"
      autoComplete="current-text"
    /> 
<TextField
      id="date"
      label="Date"
      type="date"
      autoComplete="current-text"
    />

<TextField
      id="others"
      label="Others"
      multiline
      rows={4}
    />



<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
       { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
       : <Button  variant="outlined" size={"large"} >Submit processing</Button>
  }
  </div>
      
    </Box>

  

   
)
}


const service=()=>{

  
  const Food=[
    {value:"Cereals"},
    {value: "Industrial crops"}, 
    {value:"Legumes"},
    {value:"Fruits"},
    {value:"Vegetables"},
    {value:"Starchy"},
    {value:"tuber"},
    {value: "root crops"}
  ]




  const addService= () =>{
    setloading(true)
   console.log("props.chosen")
   console.log(props.chosen)
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/service/editservice/",
            {
              
              _id:props.chosen.id,
                servicename: document.getElementById("servicename").value,
                charge: document.getElementById("charge").value,
                description: document.getElementById("description").value,
                other: document.getElementById("other").value,

            }).then(res => {
             
                if (res.status === 200) {
                console.log( "res")
                console.log( res)
                    setloading(false) 
                     
                    dispatch(getservice({
                      data: res.data

                  }))
                  handleClose()
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}



console.log(props)

  return(
  
       <Box
          component="form"
          sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
          noValidate
          autoComplete="off"
        >
              <TextField
              id="servicename"
              label="Service Name"
              type="text"
              defaultValue={props.chosen.servicename?props.chosen.servicename:""}
              autoComplete="current-text"
            />  
              
              <TextField
              id="charge"
              label="Service Charge"
              type="text"
              defaultValue={props.chosen.charge?props.chosen.charge:""}

              autoComplete="current-text"
              InputProps={{
                startAdornment: <InputAdornment position="start">GHC</InputAdornment>,
              }}
            />  
               
             <TextField
              id="description"
              label="Service Description"
              defaultValue={props.chosen.description?props.chosen.description:""}

              multiline
              rows={4}
            />
            
            <TextField
              id="other"
              label="Other Information"
              multiline
              defaultValue={props.chosen.other?props.chosen.other:""}

              rows={4}
            />
    
    <div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
            { loading?<Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
             :<Button  variant="outlined" startIcon={<Category />} size={"large"} onClick={addService}>Edit Service</Button>
        }
             </div>
              
            </Box>

    

  )

}

var lister = vehicle
  const vehicleschange=(e)=>{
     
  var insurance = personName
  var expirydate = document.getElementById("expiry").value
  var registration = document.getElementById("registration").value
  var drivername = document.getElementById("drivername").value
  var licensenum = document.getElementById("licensenum").value
  var list={insurance:insurance, expirydat:expirydate, registration:registration, drivername:drivername, licensenum:licensenum}
  lister.push(list)
  
  setvehicle(lister)
  
  }
  

const hauller=()=>{

  const addfarmer= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://servermain.sisrevolution.com/api/students/discount/",
            {
                haullier: document.getElementById("haullier").value,
                contact: document.getElementById("contact").value,
                years: document.getElementById("years").value,
                gender: gender,
                address: document.getElementById("address").value,
                numvehicles: document.getElementById("numvehicles").value,
                vehicleslist: vehicle, // list all vehicles [{},{}]
                principalID: document.getElementById("principalID").value,
                email: document.getElementById("email").value,
                capacity: document.getElementById("capacity").value,
                haulliagetype: haulliagetype,
                ownershiptype: ownershiptype,
                
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false)
                    dispatch(gethauller({

                      data: res.data

                  }))  
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)    
}
    }

    doer()

}


const names = [

  "Comprehensive",
  "Third party",
  "Goods in transit",

];


return (
  <div>
   
    <Button variant="outlined"  onClick={handleOpen}>Edit Haullier / Agent</Button>
    
    <Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
          Edit Haullier / Agent
    
      <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
     
  </DialogTitle>
  <Divider/>
<DialogContent>

        <Box
    component="form"
    sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
    noValidate
    autoComplete="off"
  >
        <TextField
        id="haullier"
        label="Haullier's Name"
        type="text"
        autoComplete="current-text"
      />  
      
      <TextField
        id="outlined-select-currency-native"
        select
        label="Gender"
        // defaultValue="Gender"
        value={gender}
        onChange={(e)=>setgender(e)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
        
          <option key="none" value="none">Choose</option>
          <option key="Male" value="Male">Male</option>
          <option key="Female" value="Female">Female </option>
          <option key="Co-operate" value="Co-operate">Co-operate </option>
      
      </TextField>
      
      <TextField
        id="years"
        label="Years in business"
        type="text"
        // defaultValue={}
        autoComplete="current-text"
        InputProps={{
          endtAdornment: <InputAdornment position="send">years</InputAdornment>,
        }}
      /> 
      <TextField
        id="contact"
        label="Contact"
        type="tel"
        autoComplete="current-text"
      />  

      <TextField
        id="address"
        label="Address"
        type="tel"
        autoComplete="current-text"
      /> 
 
<div style={{border:"solid", borderRadius:"5px", borderColor:"gray", borderWidth:"1px", margin:"7px"}}>
<p style={{textAlign:"center"}}><b>Add Vehicle</b></p>
<FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Insurance Terms</InputLabel>
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        // id="outlined-select-currency-native"
        // label="Equipment"
        value={personName}
        onChange={handleChange}
        input={<OutlinedInput label="Insurance Terms" />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={MenuProps}
      >
        {names.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={personName.includes(name)} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>

      </FormControl>
        
      <TextField
        id="expiry"
        label="Insurance Expiry"
        type="date"
        autoComplete="current-text"
        InputProps={{
          startAdornment: <InputAdornment position="start"></InputAdornment>,
        }}
      />
      <TextField
        id="registration"
        label="Vehicle Registration"
        type="text"
        autoComplete="current-text"
      />  
      <TextField
        id="drivername"
        label="Driver's Name"
        type="text"
        autoComplete="current-text"
      />  
      <TextField
        id="licensenum"
        label="Driver's License Number"
        type="text"
        autoComplete="current-text"
      /> <br/>
      <div style={{textAlign:"center", marginBottom:"5px"}}>
       <Button type="button" onClick={vehicleschange} variant='outlined'>Add Vehicle to Hallier</Button>
       </div>
</div>

{/* <div style={{border:"solid", borderRadius:"5px", borderColor:"gray", borderWidth:"1px", margin:"7px"}}> */}
{lister.map((i, index)=>
<>
<p style={{textAlign:"center"}}>Vehicle {index+1}</p>
</>
)}

{/* </div> */}

      <TextField
        id="outlined-select-currency-native"
        select
        label="Haulliage Type"
        // defaultValue="Ownership Type"
        value={haulliagetype}
        onChange={(e)=>sethaulliagetype(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
          <option key="none" value="none">Choose</option>
          <option key="Primary" value="Primary">Primary</option>
          <option key="Secondary" value="Secondary">Secondary</option>
      
      </TextField> 

      <TextField
        id="principalID"
        label="Principal Agent ID"
        type="text"
        autoComplete="current-text"
      /> 
      <TextField
        id="email"
        label="Email"
        type="email"
        autoComplete="current-text"
      /> 

        <TextField
        id="capacity"
        label="Haullage Capacity"
        type="text"
        autoComplete="current-text"
        InputProps={{
          endAdornment: <InputAdornment position="end">tons</InputAdornment>,
        }}
      /> 

  
      <TextField
        id="outlined-select-currency-native"
        select
        label="Ownership Types"
        // defaultValue="Crop Types"
        value={ownershiptype}
        onChange={(e)=>setownershiptype(e.target.value)}
        slotProps={{
          select: {
            native: true,
          },
        }}
      //   helperText="Please select category"
      >
          <option key="none" value="none">Choose</option>
          <option key="Owned" value="Owned">Owned</option>
          <option key="Leased" value="Leased">Leased</option>
          <option key="Co-operative" value="Co-operative">Co-operative</option>
      
      </TextField>
   
      </Box>

</DialogContent>
<Divider/>
  <DialogActions>


<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
           { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
           : <Button  variant="outlined" startIcon={<EngineeringIcon />} size={"large"} onClick={addfarmer}>Submit New Haullier / Agent</Button>
      }
      </div>

      
  </DialogActions>
</Dialog>


  </div>
);


}


const warehouse=()=>{
  var listequipments=[]

  const names = [

    "Forklifts",
    "Pallet jacks",
    "Scale",
    "Tarpaulin",
    "Moisture meter",
    "Conveyors",
    "Automated guided vehicles (AGVs)",
    "Sorting systems"

  ];


  const crops = [
    "Maize",
    "Soya Beans",
    "Onion",
    "Pepper",
    "Tomatoes"

  ];


  const Food=[
    {value:"Cereals"},
    {value: "Industrial crops"}, 
    {value:"Legumes"},
    {value:"Fruits"},
    {value:"Vegetables"},
    {value:"Starchy"},
    {value:"tuber"},
    {value: "root crops"}
  ]


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };


  const handleChangecrops = (event) => {
    const {
      target: { value },
    } = event;
    setmulticrops(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };


  
  const addwarehouse= () =>{
    setloading(true)
   for (var i in personName){
    var value = document.getElementById("quantity"+i).value
    var list = [personName[i],value]

    listequipments.push(list)

   }
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/warehouse/editwarehouse/",
            {
                warehousename: document.getElementById("warehousename").value,
                address: document.getElementById("address").value,
                contact: document.getElementById("contact").value,
                warehousetype: warehousetype,
                equipments: personName,
                crops: multicrops,
                equipmentsquantity: listequipments, // do the quantity
                storagesize: document.getElementById("storagesize").value,
                description: document.getElementById("description").value,
                gpslocation: document.getElementById("gpslocation").value,
            
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log(res)
                    dispatch(getwarehouse({

                      data: res.data

                  })) 
                  handleClose()
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            console.log(err)
            setloading(false)
           
}
    }

    doer()

   

  

}





    return(
         
         
      <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          <TextField
          id="warehousename"
          label="Warehouse Name"
          type="text"
          defaultValue={props.chosen.warehousename}
          autoComplete="current-text"
        />  

<TextField
          id="address"
          label="Address"
          type="text"
          defaultValue={props.chosen.address}

          autoComplete="current-text"
        />

<TextField
          id="gpslocation"
          label="Location (GPS)"
          type="text"
          defaultValue={props.chosen.gpslocation}
          autoComplete="current-text"
        /> 


<TextField
          id="contact"
          label="Contact"
          type="tel"
          defaultValue={props.chosen.contact}

          autoComplete="current-text"
        /> 


        
        <TextField
          id="outlined-select-currency-native"
          select
          label="Warehouse Type"
          // defaultValue="Category"
          value={warehousetype}
          onChange={(e)=>setwarehousetype(e.target.value)} 
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none"> Choose </option>
            <option key="Primary" value="Primary"> Primary </option>
            <option key="Secondary" value="Secondary"> Secondary </option>
         
        </TextField>

        <TextField
          id="storagesize"
          label="Storage Area Size"
          type="text"
          defaultValue={props.chosen.storagesize}

          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end">tons</InputAdornment>,
          }}
        />  
          
          

<FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Equipment</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          // id="outlined-select-currency-native"
          // label="Equipment"
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="Equipment" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={personName.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>

        </FormControl>
          
      <br/>
{personName.map((index,i)=>
      <div>
  <TextField
          id={"equipment"+i}
          label="Equipment"
          value={index}
          type="text"
          disabled
          autoComplete="current-text"
        />  
        <TextField
        id={"quantity"+i}
        label="ID Number"
        type="text"
        autoComplete="current-text"
      /> 
      </div>
)}

<FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Crops Kept</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          // id="outlined-select-currency-native"
          // label="Equipment"
          value={multicrops}
          onChange={handleChangecrops}
          input={<OutlinedInput label="Crops Kept" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {crops.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={multicrops.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>

        </FormControl>
          

         <TextField
          id="description"
          label="Warehouse Description"
          multiline
          rows={4}
        />


<div style={{marginTop:2, textAlign:"center"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
              :<Button  variant="outlined" size={"large"} onClick={addwarehouse}>Submit New Warehouse</Button>
}
              </div>
          
        </Box>

         
    )
}


const staff=()=>{

  const Food=[
    {value:"Cereals"},
    {value: "Industrial crops"}, 
    {value:"Legumes"},
    {value:"Fruits"},
    {value:"Vegetables"},
    {value:"Starchy"},
    {value:"tuber"},
    {value: "root crops"}
  ]
 

  const names = [

    "Mobile Phone",
    "Vehicle",
    "Motorbike",
    "Computer",
  
  ];
  


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const imagehandler = (e) => {
    const reader = new FileReader()
    reader.onload = () => {
        if (reader.readyState === 2) {
            setperson(reader.result)
        }
    }

    reader.readAsDataURL(e.target.files[0])
}


  // functions

  const addfarmer= () =>{

    console.log("props.chosen")
    console.log(props.chosen)
    setloading(true)
    const file = document.getElementById("fileimage").files[0]
    const image = ""
      console.log("props.chosen")
      console.log(props.chosen)
    const fd = new FormData()
                    
                    if (file) {
                      
                        fd.append("file", file)
                        fd.append("image", document.getElementById("fileimage").files[0].name)
                        
                    }

    fd.append("_id", props.chosen.id)
    fd.append("surname", document.getElementById("surname").value)
    fd.append("othername", document.getElementById("othername").value)
    fd.append("lastname", document.getElementById("lastname").value)
    fd.append("contact", document.getElementById("contact").value)
    fd.append("idnumber", document.getElementById("idnumber").value)
    fd.append("email", document.getElementById("email").value)
    fd.append("ssnit", document.getElementById("ssnit").value)
    fd.append("gender", gender)
    fd.append("dob", document.getElementById("dob").value)
    fd.append("license", document.getElementById("license").value)
    fd.append("expiry", document.getElementById("expiry").value)
    fd.append("dateemployed", document.getElementById("dateemployed").value)
    fd.append("iniposition", iniposition)
    fd.append("position", position)
    fd.append("employmenttype", employmenttype)
    fd.append("marrital", marrital)
    fd.append("assetusage",personName)
    fd.append("others", document.getElementById("others").value)



      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/staff/editstaff/",fd, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false)

                    dispatch(getstaff({

                      data: res.data

                  })) 
                  handleClose()
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}


return (
  <div>
   
   
    <Button variant="outlined"  onClick={handleOpen}>Edit Staff</Button>
    


    <Dialog fullWidth minWidth="sm" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
         Edit Staff
    
      <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
     
  </DialogTitle>
  <Divider/>
<DialogContent>


          <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="on"
    >

<div style={{ width: "100%", textAlign:"center", marginBottom:"20px" }}>



<input

    style={{ display: "none" }}
    id="fileimage"
    multiple
    type="file"
    onChange={(e) => imagehandler(e)}
/>
<label htmlFor="fileimage">
    <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={
            <CameraAltIcon style={{ cursor:"pointer", backgroundColor: "darkblue", padding: 6, borderRadius: "100%", color: "white", fontSize: "26px" }} />
        }
    >
        <Avatar style={{ width: 100, height: 100, border: "solid", borderColor: "#f0f0f0" }} alt="Travis Howard" src={person} />

    </Badge>

</label>


</div>
          <TextField
          id="surname"
          label="Surname"
          type="text"
          defaultValue={props.chosen.surname}
          autoComplete="current-text"
        /> 
          <TextField
          id="othername"
          label="Other Names"
          type="text"
          defaultValue={props.chosen.othername}

          autoComplete="current-text"
        />  <TextField
          id="lastname"
          label="Last Names"
          type="text"
          defaultValue={props.chosen.lastname}

          autoComplete="current-text"
        /> 
           
           <TextField
          id="dob"
          label="Date Of Birth"
          type="date"
          defaultValue={props.chosen.dob}

          // defaultValue={}
          autoComplete="current-text"
          InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
        /> 
         
         <TextField
          id="idnumber"
          label="ID Number"
          type="text"
          defaultValue={props.chosen.idnumber}

          autoComplete="current-text"
        />    
         <TextField
          id="ssnit"
          label="SSNIT"
          type="text"
          defaultValue={props.chosen.ssnit}

          autoComplete="current-text"
        />    
        <TextField
          id="license"
          label="Driver's License Number"
          type="text"
          defaultValue={props.chosen.license}

          autoComplete="current-text"
        />  
         <TextField
          id="expiry"
          label="License Expiry Date"
          type="date"
          defaultValue={props.chosen.expiry}

          autoComplete="current-text"
          InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
        />  
        
        <TextField
          id="outlined-select-currency-native"
          select
          label="Gender"
          // defaultValue="Gender"
          value={gender}
          onChange={(e)=>setgender(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
          
            <option key="none" value="none">Choose</option>
            <option key="Male" value="Male">Male</option>
            <option key="Female" value="Female">Female </option>
        
        </TextField>  
  
        <TextField
          id="dateemployed"
          label="Date Employed"
          type="date"
          defaultValue={props.chosen.dateemployed}

          // defaultValue={}
          autoComplete="current-text"
          InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
        /> 
        <TextField
          id="outlined-select-currency-native"
          select
          label="Employment Type"
          // defaultValue="Gender"
          value={employmenttype}
          onChange={(e)=>setemploymenttype(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
          
            <option key="none" value="none">Choose</option>
            <option key="Permanent" value="Permanent">Permanent</option>
            <option key="Temporal" value="Temporal">Temporal </option>
            <option key="Contract" value="Contract">Contract </option>
        
        </TextField>
     
        <TextField
          id="contact"
          label="Contact"
          type="tel"
          defaultValue={props.chosen.contact}

          autoComplete="current-text"
        />  

        <TextField
          id="email"
          label="email"
          type="email"
          defaultValue={props.chosen.email}

          autoComplete="current-text"
        />  

        <TextField
          id="address"
          label="Address"
          type="tel"
          defaultValue={props.chosen.address}

          autoComplete="current-text"
        /> 
        

        <TextField
          id="outlined-select-currency-native"
          select
          label="Marrital Status"
          // defaultValue="Ownership Type"
          value={marrital}
          onChange={(e)=>setmarrital(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">Choose</option>
            <option key="Single" value="Single">Single</option>
            <option key="Married" value="Married">Married</option>
            <option key="Divorced" value="Divorced">Divorced</option>
            <option key="Complicated" value="Complicated">Complicated</option>
        
        </TextField>

        <TextField
          id="outlined-select-currency-native"
          select
          label="Initial Position"
          // defaultValue="Ownership Type"
          value={iniposition}
          onChange={(e)=>setiniposition(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">Choose</option>
            <option key="Manager" value="Manager">Manager</option>
            <option key="Secretary" value="Secretary">Secretary</option>
            <option key="Field Agent" value="Field Agent">Field Agent</option>
            <option key="Sourcing Agent" value="Sourcing Agent">Sourcing Agent</option>
            <option key="Driver" value="Driver">Driver</option>
            <option key="Security" value="Security">Security</option>
            
        
        </TextField>
  <TextField
          id="outlined-select-currency-native"
          select
          label="Current Position"
          // defaultValue="Ownership Type"
          value={position}
          onChange={(e)=>setposition(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">Choose</option>
            <option key="Manager" value="Manager">Manager</option>
            <option key="Secretary" value="Secretary">Secretary</option>
            <option key="Field Agent" value="Field Agent">Field Agent</option>
            <option key="Sourcing Agent" value="Sourcing Agent">Sourcing Agent</option>
            <option key="Driver" value="Driver">Driver</option>
            <option key="Security" value="Security">Security</option>
            
        
        </TextField>

        <FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Asset Usage</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          // id="outlined-select-currency-native"
          // label="Equipment"
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="Asset Usage" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={personName.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>

        </FormControl>
        

         <TextField
          id="others"
          defaultValue={props.chosen.others}

          label="Other Descriptions"
          multiline
          rows={4}
        />
         
        </Box>
 
</DialogContent>
<Divider/>
  <DialogActions>

<div style={{marginTop:2, textAlign:"center", width:"100%"}}>    
           { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
           : <Button  variant="outlined"  size={"large"} onClick={addfarmer}>Edit Staff</Button>
      }
      </div>

      
  </DialogActions>
</Dialog>









  </div>
)



}


const processing=()=>{

const names=[]

  
  const addwarehouse= () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/center/editprocessingcenter/",
            {
                centername: document.getElementById("centername").value,
                address: document.getElementById("address").value,
                gpslocation: document.getElementById("gpslocation").value,
                contact: document.getElementById("contact").value,
                capacity: document.getElementById("capacity").value,
                rawmat: document.getElementById("rawmat").value,
                finished: document.getElementById("finished").value,
                product: productpro,
                equipments: personName,
               
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    dispatch(getprocessingcenter({

                      data: res.data

                  })) 
                  handleClose()
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            setloading(false)
           
}
    }

    doer()

   

  

}



    return(
          
        <Box
        component="form"
        sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
        noValidate
        autoComplete="off"
      >
            <TextField
            id="Processing Centername"
            label="Processing Center Name"
            type="text"
            defaultValue={props.chosen.centername?props.chosen.centername:""}
            autoComplete="current-text"
          />  
  
  <TextField
            id="address"
            label="Address"
            type="text"
            defaultValue={props.chosen.address?props.chosen.address:""}

            autoComplete="current-text"
          />
  
  <TextField
            id="gpslocation"
            label="Location (GPS)"
            type="text"
            defaultValue={props.chosen.gpslocation?props.chosen.gpslocation:""}

            autoComplete="current-text"
          /> 
  
  
  <TextField
            id="contact"
            label="Contact"
            type="tel"
            defaultValue={props.chosen.contact?props.chosen.contact:""}

            autoComplete="current-text"
          /> 
  
  
          
  <TextField
            id="outlined-select-currency-native"
            select
            label="Processing capabilities"
            // defaultValue="Category"
            value={capacity}
            onChange={(e)=>setcapacity(e.target.value)} 
            slotProps={{
              select: {
                native: true,
              },
            }}
          //   helperText="Please select category"
          >
              <option key="none" value="none"> Choose </option>
              <option key="Distribution Center" value="Distribution Center"> Distribution Center </option>
              <option key="Fulfillment Center" value="Fulfillment Center"> Fulfillment Center </option>
              <option key="Refrigerant" value="Refrigerant"> Refrigerant </option>
              <option key="Dry Storage" value="Dry Storage"> Dry Storage </option>
           
          </TextField>
  
          
          <TextField
            id="outlined-select-currency-native"
            select
            label="Processing Center Type"
            // defaultValue="Category"
            value={centertype}
            onChange={(e)=>setcentertype(e.target.value)} 
            slotProps={{
              select: {
                native: true,
              },
            }}
          //   helperText="Please select category"
          >
              <option key="none" value="none"> Choose </option>
              <option key="Distribution Center" value="Distribution Center"> Distribution Center </option>
              <option key="Fulfillment Center" value="Fulfillment Center"> Fulfillment Center </option>
              <option key="Refrigerant" value="Refrigerant"> Refrigerant </option>
              <option key="Dry Storage" value="Dry Storage"> Dry Storage </option>
           
          </TextField>
  
          <TextField
            id="capacity"
            label="Processing Capacity"
            type="text"
            defaultValue={props.chosen.capacity?props.chosen.capacity:""}

            autoComplete="current-text"
            InputProps={{
              endAdornment: <InputAdornment position="end"> Tone/day</InputAdornment>,
            }}
          />  
            
            <TextField
          id="rawmat"
          label="Raw Material Storage Capacity"
          type="text"
          defaultValue={props.chosen.rawmat?props.chosen.rawmat:""}

          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end"> Tons</InputAdornment>,
          }}
        />  
 <TextField
          id="finished"
          label="FInished Products Storage Capacity"
          type="text"
          defaultValue={props.chosen.finished?props.chosen.finished:""}

          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end"> Tons</InputAdornment>,
          }}
        />  

  
  <FormControl sx={{ m: 1, width: 225 }}>
  
  <InputLabel id="demo-multiple-checkbox-label">Equipment</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            // id="outlined-select-currency-native"
            // label="Equipment"
            value={personName}
            onChange={handleChange}
            input={<OutlinedInput label="Equipment" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {names.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={personName.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
  
          </FormControl>
            
        
  
           <TextField
            id="others"
            defaultValue={props.chosen.others?props.chosen.others:""}

            label="Processing Center Description"
            multiline
            rows={4}
          />
  
  
            
          </Box>
  
         
    )
}



const TAX_RATE = 0.07;

function ccyFormat(num) {
  return `${num.toFixed(2)}`;
}

function priceRow(qty, unit) {
  return (parseFloat(qty) * parseFloat(unit));
}

function createRow(desc, qty, unit) {
  const price = priceRow(qty, unit);
  return { desc, qty, unit, price };
}

function subtotal(items) {
  return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
}

const rows = [
  createRow('Paperclips (Box)', 100, 1.15),
  createRow('Paper (Case)', 10, 45.99),
  createRow('Waste Basket', 2, 17.99),
];

const invoiceSubtotal = subtotal(rows);
const invoiceTaxes = TAX_RATE * invoiceSubtotal;
const invoiceTotal = invoiceTaxes + invoiceSubtotal;

const totalinvoice=(list)=>{
var total=0
for (var i in list){
  total+= (parseFloat(list[i].unitp) * parseFloat(list[i].qty))
}

return ccyFormat(total)
}


const approve=()=>{

  return(

    <>
    <p><b> Approve Purchase Order </b></p>
    <Button variant="outlined"> Approve For Supply </Button>
    <List sx={{ width: '100%'}}>
                  <ListItem>
                      <ListItemText primary={props.chosen.customer} secondary="Customer" />
                  </ListItem>
                  <Divider /> 
                  <ListItem>
                      <ListItemText primary={props.chosen.product} secondary="Product" />
                  </ListItem>
                  <Divider />  
                  <ListItem>
                      <ListItemText primary={props.chosen.quantity} secondary={"Quantity "+props.chosen.unit} />
                  </ListItem>
                  <Divider />  
                  <ListItem>
                      <ListItemText primary={+"GHC "+props.chosen.unitprice} secondary="Unit Price" />
                  </ListItem>
                  <Divider />  
                  <ListItem>
                      <ListItemText primary={props.chosen.paymentmethod} secondary="Payment Method" />
                  </ListItem>
                  <Divider /> 
                  <ListItem>
                      <ListItemText primary={props.chosen.tax} secondary="Tax" />
                  </ListItem>
                  <Divider /> 
                  <ListItem>
                      <ListItemText primary={props.chosen.others} secondary="Others" />
                  </ListItem>
                  <Divider /> 
                  

              </List>
  </>

  )


}


const supply=()=>{
  const idmain = "SA"+year+"0Q"+month+"00"+(sales.length % parseInt(day))

  const Food=[
    {value:"Cereals"},
    {value: "Industrial crops"}, 
    {value:"Legumes"},
    {value:"Fruits"},
    {value:"Vegetables"},
    {value:"Starchy"},
    {value:"tuber"},
    {value: "root crops"}
  ]
 
  const names = [

    "Maize",
    "Soya Beans",
    "Onion",
    "Pepper",
    "Tomatoes"

  ];

  var data= []
  if(props.chosen.purchase && props.chosen.purchase.length!==0){
    for(var i in props.chosen.purchase ){
      data.push([props.chosen.purchase[i].product])
    }

    // setPersonName(data)

    }
    
    const addfarmer= () =>{
      
      setloading(true)
      var list=[]
     
      for (var i in data){
  var product = data[i]
  var qty =  document.getElementById(data[i]+i).value
  var unitp =  document.getElementById(data[i]+"unitp"+i).value
  var contact = chosenhaullier.vehicleslist ? chosenhaullier.vehicleslist.filter(bug=>bug.drinername===drivername)[0].contact:""
  list.push({product:product, qty:qty, unitp:unitp})
      
    }
     
        const doer = async () => {
          
          try{
  
          await axios.post("https://server.agrotraciserp.com/api/sales/addsales/",
              {
                  // unitprice: document.getElementById("amount").value,
                  // quantity: document.getElementById("quantity").value,
                  shippedvia: document.getElementById("shippedvia").value,
                  fobpoint: document.getElementById("fobpoint").value,
                  tax: document.getElementById("tax").value,
                  customertype: customertype,
                  unit: unit,
                  haullier: haullier,
                  drivername: drivername,
                  drivernumber: contact,
                  vehicle: vehicleregistration,
                  purchase: props.chosen.purchase,
                  supply: list,
                  invoice: idmain,
                  customer: customer,
                  paymentmethod: method,
                  others: document.getElementById("others").value,               
  
              }).then(res => {
  
                  if (res.status === 200) {
                  
                      setloading(false) 
                      dispatch(getsales({
  
                        data: res.data
  
                    })) 
                      
                  } else {
                      setloading(false)
                    
                  }
  
              })
            }catch(err){
              setloading(false)
             
  }
      }
  
      doer()
  
     
  
    
  
  }
  


  const haullierchooser=(data)=>{

    sethaullier(data)
    console.log(data)
    var chosendata = haullier_.filter(bug=>bug.haullier===data)
     console.log(chosendata)
    setchosenhaullier(chosendata)
  
  }
  



  return(

    <>
    <p><b> Supply Goods </b></p>
    <Button onClick={addfarmer} variant="outlined"> Approve For Supply </Button>
    

    
              <Box
          component="form"
          sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
          noValidate
          autoComplete="off"
        >
          
    
        <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Customer"
              // defaultValue="Ownership Type"
              value={customer}
              // onChange={(e)=>setcustomer(e.target.value)}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            //   helperText="Please select category"
            >
                <option key="none" value="none">Choose</option>
              {
                customer_.map((list,i)=>
                  <option key={list.businessname} value={list.businessname}>{list.businessname}</option>
    
                )
              }
            </TextField>
    
    
    
            <FormControl sx={{ m: 1, width: 225 }}>
    
    <InputLabel id="demo-multiple-checkbox-label">Choose Product(s)</InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              // id="outlined-select-currency-native"
              // label="Equipment"
              value={data}
              onChange={handleChange}
              input={<OutlinedInput label="Choose Product(s)" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
            >
              {names.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={data.includes(name)} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
    
            </FormControl>
    
          
          {
    
    data.map((list,i)=>
    <div style={{border:"solid", borderWidth:"1px", borderRadius:"5px", borderColor:"gray", padding:"10px"}}>
    
    <TextField
              id={list+i}
              label={list+" Quantity"}
              type="text"
              // defaultValue={}
              autoComplete="current-text"
            /> 
    <TextField
              id={list+"unitp"+i}
              label={list+" Unit Price"}
              type="text"
              // defaultValue={}
              autoComplete="current-text"
            /> 
    
    
    </div>
    
          )}
    
    
    
    
            
            {/* <TextField
              id="quantity"
              label="Quantity"
              type="text"
              // defaultValue={}
              autoComplete="current-text"
            />  */}
              <TextField
              id="outlined-select-currency-native"
              select
              label="Measuring Unit"
              // defaultValue="Ownership Type"
              value={unit}
              onChange={(e)=>setunit(e.target.value)}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            //   helperText="Please select category"
            >
                <option key="none" value="none">Choose</option>
                <option key="Kg" value="Kg">Kg</option>
                <option key="Tons" value="Tons">Tons</option>
                <option key="bags" value="bags">bags</option>
            
            </TextField>
    
            {/* <TextField
              id="amount"
              label="Unit Price"
              type="number"
              autoComplete="current-text"
              InputProps={{
                startAdornment: <InputAdornment position="start"> GHC</InputAdornment>,
              }}
            />    */}
    
            
        <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Haullier"
              // defaultValue="Ownership Type"
              value={haullier}
              onChange={(e)=>haullierchooser(e.target.value)}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            //   helperText="Please select category"
            >
                <option key="none" value="none">Choose</option>
              {
                haullier_.map((list,i)=>
                  <option key={list.haullier} value={list.haullier}>{list.haullier}</option>
    
                )
              }
            </TextField>
    
    
                
        <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Driver"
              // defaultValue="Ownership Type"
              value={drivername}
              onChange={(e)=>setdrivername(e.target.value)}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            //   helperText="Please select category"
            >
                <option key="none" value="none">Choose</option>
                
              {
                chosenhaullier.length!==0 && chosenhaullier[0].vehicleslist.map((list,i)=>
                  <option key={list.drivername} value={list.drivername}>{list.drivername}</option>
    
                )
              }
            </TextField>
    
              
        <TextField
              id="outlined-select-currency-native"
              select
              label="Vehicle Registration"
              // defaultValue="Ownership Type"
              value={vehicleregistration}
              onChange={(e)=>setvehicleregistration(e.target.value)}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            //   helperText="Please select category"
            >
                <option key="none" value="none">Choose</option>
              {
                chosenhaullier.length!==0 && chosenhaullier[0].vehicleslist.map((list,i)=>
                  <option key={list.registration} value={list.registration}>{list.registration}</option>
    
                )
              }
            </TextField>
    
    
            
            <TextField
              id="shippedvia"
              label="Shipped Via"
              type="text"
              autoComplete="current-text"
             
            />  
            <TextField
              id="fobpoint"
              label="FOB Point"
              type="text"
              autoComplete="current-text"
             
            />    
            
            <TextField
              id="tax"
              label="Tax"
              type="text"
              autoComplete="current-text"
              
            />  
           
           <TextField
              id="outlined-select-currency-native"
              select
              label="Payment Method"
              // defaultValue="Ownership Type"
              value={method}
              onChange={(e)=>setmethod(e.target.value)}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            //   helperText="Please select category"
            >
                <option key="none" value="none">Choose</option>
                <option key="Cash" value="Cash">Cash</option>
                <option key="Cheque" value="Cheque">Cheque</option>
                <option key="Credit" value="Credit">Credit</option>
            
            </TextField>
              
          
             <TextField
              id="others"
              label="Other Descriptions"
              multiline
              rows={4}
            />
    
            </Box>
    
    
  </>

  )


}

const invoice=()=>{
var chosencustomer = customer_.filter(bug=>bug.businessname===props.chosen.customer)
  return(

    <div>
   <ReactToPrint
             pageStyle='@page { size: A4; margin: 0mm; } @media print { body { scale:1; font-size:8pt; font-family:georgia, times, serif; } }'
           
           trigger={()=><Button>Print invoice</Button>}
            content ={()=>componentRefinvoice.current}
            />


      <div style={{margin:"20px", marginTop:"-15px"}} ref={componentRefinvoice} ><br/>
    <div style={{border:"solid", borderWidth:"1px", borderColor:"grey"}}>
      <p align="center">
        <img src={Logo}  style={{width:"70px", }}/> <br/>
      <b>EMBETT AGRO GHANA LTD</b> <br/>
      <b>INVOICE</b>
        </p>
    </div>
    <p align="center"> 
        <small>P.O. BOX HS8504 AHINSAN KUMASI</small><br/> 
        <small>PLOT 38 BLOCK 38, AYIGYA ESTATE</small> <br/>
        <small>GPS : AK-388-7405</small> <br/>
        <small>TEL : +233 205645027 0R +223 244635134</small> <br/>
        </p>
    <div>
    
    <div style={{display:"flex", width:"100%"}}>

<div style={{width:"49%"}}>
<p> <b> Bill To : </b><span editable={true}>{props.chosen.customer}</span> </p>
<p> <b> Address : </b><span editable={true}>{chosencustomer.length!==0 && chosencustomer[0].address}</span> </p>
<p> <b> Phone : </b><span editable={true}>{chosencustomer.length!==0 && chosencustomer[0].contact}</span> </p>
</div>

<div style={{width:"49%"}}>

<p> <b> Date : </b>{props.chosen.date} </p>
<p> <b> Invoice No. : </b>{props.chosen.id.slice(0,8)? props.chosen.id.slice(0,8).toUpperCase():""} </p>

</div>

</div>

    </div>


<Tablemain data={props.chosen.purchase} amount={ccyFormat(priceRow())} total={(totalinvoice(props.chosen.purchase))} />


    {/* <TableContainer >
      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
       
       <TableHead>

          <TableRow>
            <TableCell>S/N</TableCell>
            <TableCell align="left">Description</TableCell>
            <TableCell align="left">Qty (Kg)</TableCell>
            <TableCell align="left">Unit Price (GHC)</TableCell>
            <TableCell align="left">Amount (GHC)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.chosen.purchase && props.chosen.purchase.map((row,i) => (
            <TableRow key={i+1}>
              <TableCell>{i+1}</TableCell>
              <TableCell > <span editable > {row.product}</span></TableCell>
              <TableCell editable align="left">{row.qty}</TableCell>
              <TableCell editable align="left">{ccyFormat(parseFloat(row.unitp))}</TableCell>
              <TableCell editable align="left">{ ccyFormat(priceRow(row.qty, row.unitp))}</TableCell>
            </TableRow>
          ))}
          <TableRow rowSpan={1}>
            <TableCell  />
            <TableCell  />
            <TableCell  />
            <TableCell  > <b>Total</b></TableCell>
            <TableCell editable={true} align="left"> <b>{(totalinvoice(props.chosen.supply))}</b></TableCell>
          </TableRow>
         
        </TableBody>
      </Table>
    </TableContainer> */}

    {/* <div style={{width:"65%", border:"solid", borderWidth:"1px", paddingLeft:"10px", marginTop:"20px", borderRadius:"5px", borderColor:"grey", height:"150px"}}>
<p>Make all payments to:</p>



    </div> */}

<textarea rows={6} style={{width:"100%", }}/>

    <p><b>Issued By:....................................</b></p>
  
    <p><b>Name:....................................</b></p>
    
    <p><b>Signature:........................................</b></p>
   
    <p><b>Date:.............................................</b></p>
    </div>
    </div>
  );



}

const purchaseorder=()=>{
  var chosencustomer = customer_.filter(bug=>bug.businessname===props.chosen.customer)


  return(
<div>
<ReactToPrint
             pageStyle='@page { size: A4; margin: 0mm; } @media print { body { scale:1; font-size:8pt; font-family:georgia, times, serif; } }'
           
           trigger={()=><Button>Print Purchase Order</Button>}
            content ={()=>componentRefpurchase.current}
            />
    <div style={{margin:"20px", marginTop:"-15px"}} ref={purchaseorder}>
    <div>
      <br/>
    <div style={{border:"solid", borderWidth:"1px", borderColor:"grey"}}>
      <p align="center">
      <img src={Logo}  style={{width:"70px", }}/> <br/>

      <b>EMBETT AGRO GHANA LTD</b> <br/>
      <b>PURCHASE ORDER</b>
        </p>
    </div>
<p> <b> To : </b>{props.chosen.customer} </p>
<p> <b> Address : </b>{chosencustomer.length!==0 && chosencustomer[0].address} </p>
<p> <b> Phone : </b>{chosencustomer.length!==0 && chosencustomer[0].contact} </p>
<p> <b> NO. : </b>{props.chosen.id.slice(0,8)} </p>
    </div>
    <TableContainer >
      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              LPO Date
            </TableCell>
            <TableCell align="left">Requisitioner</TableCell>
            <TableCell align="left">Shipped Via</TableCell>
            <TableCell align="left">FOB Point</TableCell>
            <TableCell align="left">Terms</TableCell>
          </TableRow>
        </TableHead>

          <TableBody>
          {/* {rows.map((row) => ( */}
            <TableRow key={props.chosen.date}>
              <TableCell>{props.chosen.date}</TableCell>
              <TableCell>{props.chosen.customer}</TableCell>
              <TableCell align="left">{props.chosen.shippedvia}</TableCell>
              <TableCell align="left">{props.chosen.fobpoint}</TableCell>
              <TableCell align="left">{props.chosen.others}</TableCell>
            </TableRow>
          {/* ))} */}
          
        </TableBody>
<br/>
<br/>

        <TableHead>

          <TableRow>
            <TableCell>Quantity</TableCell>
            <TableCell align="left">Unit</TableCell>
            <TableCell align="left">Description</TableCell>
            <TableCell align="left">Unit Price</TableCell>
            <TableCell align="left">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.chosen.purchase.map((row) => (
            <TableRow key={row.desc}>
              <TableCell>{row.qty}</TableCell>
              <TableCell align="left">{props.chosen.unit}</TableCell>
              <TableCell align="left">{row.product}</TableCell>
              <TableCell align="left">{row.unitp}</TableCell>
              <TableCell align="left">{ ccyFormat(priceRow(row.qty, row.unitp))}</TableCell>
            </TableRow>
          ))}
          <TableRow>
          <TableCell  />
            <TableCell  />
            <TableCell  />
            <TableCell  style={{fontWeight:"bolder"}} >Subtotal</TableCell>
            <TableCell  style={{fontWeight:"bolder"}} align="left">{(totalinvoice(props.chosen.purchase))}</TableCell>
          </TableRow>
          <TableRow>
          <TableCell  />
            <TableCell  />
            <TableCell  />
            <TableCell style={{fontWeight:"bolder"}} >Tax</TableCell>
            <TableCell  style={{fontWeight:"bolder"}} align="left">{ccyFormat(parseFloat(props.chosen.tax))}</TableCell>
          </TableRow>
          <TableRow>
          <TableCell  />
            <TableCell  />
            <TableCell  />
            <TableCell style={{fontWeight:"bolder"}}>Total</TableCell>
            <TableCell  style={{fontWeight:"bolder"}} align="left">{ccyFormat(parseFloat((totalinvoice(props.chosen.purchase)))+parseFloat(props.chosen.tax))}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

    <p><b>Authorized By:....................................</b></p>
    <br/>
    <p><b>Signature:........................................</b></p>
    <p><b>Date:.............................................</b></p>
    <br/>
    <textarea  row={6}  style={{width:"100%"}}/>
    <small>DELIVERY TERMS: TWO (2) WEEKS FROM LPO DATE DELIVERED AT FACTORY PREMISES. FIALURE TO DELIVER WITHIN THE SAID PERIOD RENDERS LPO INVALID. PAYMENT TERMS: ONE (1) WEEK FROM DATE OF DELIVERY </small>
    </div>
    </div>
  );
}


const waybill=()=>{
  var chosencustomer = customer_.filter(bug=>bug.businessname===props.chosen.customer)


  return(
<div>
<ReactToPrint
             pageStyle='@page { size: A4; margin: 0mm; } @media print { body { scale:1; font-size:8pt; font-family:georgia, times, serif; } }'
           
           trigger={()=><Button>Print Way-Bill</Button>}
            content ={()=>componentRefwaybill.current}
            />
    <div style={{margin:"20px", marginTop:"-15px"}} ref={componentRefwaybill}>
    <div align="center">
<br/>
    <div style={{border:"solid", borderWidth:"1px", borderColor:"grey"}}>
      <p align="center">
      <img src={Logo}  style={{width:"70px", }}/> <br/>

      <b>EMBETT AGRO GHANA LTD</b> <br/>
      <b>GOODS WAY-BILL</b>
        </p>
    </div>
      
      <p> 
        <small>P.O. BOX HS8504 AHINSAN KUMASI</small><br/> 
        <small>PLOT 38 BLOCK 38, AYIGYA ESTATE</small> <br/>
        <small>GPS : AK-388-7405</small> <br/>
        <small>TEL : +233 205645027 0R +223 244635134</small> <br/>
        </p>
       </div>
 


     

     <div style={{display:"flex", width:"100%"}}>

     <div style={{width:"49%"}}>
<p> <b> From : </b>{props.chosen.from} </p>
<p> <b> To : </b>{props.chosen.to} </p>
<p> <b> Address : </b>{props.chosen.address} </p>
<p> <b> Waybill Number : </b>{props.chosen.id.slice(0,8)? props.chosen.id.slice(0,8).toUpperCase():""} </p>
</div>

<div style={{width:"49%"}}>

<p> <b> Driver's Name : </b>{props.chosen.driver} </p>
<p> <b> Vehicle NO. : </b>{props.chosen.vehicle} </p>
<p> <b> Date : </b>{props.chosen.date} </p>

</div>

    </div>


    <TableContainer >
      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
     
        <TableHead>

          <TableRow>
            <TableCell>Quantity</TableCell>
            <TableCell align="left">Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.chosen.supply && props.chosen.supply.map((row) => (
            <TableRow key={row.desc}>
              <TableCell>{row.qty}</TableCell>
              <TableCell align="left">{row.product}</TableCell>
            </TableRow>
          ))}
          
        </TableBody>
      </Table>
    </TableContainer>

    
    
    <div style={{display:"flex", width:"100%"}}>

    <div style={{width:"49%"}}>
    <p><b>Date:....................................</b></p>
    <p><b>Despatched by:....................................</b></p>
    <p><b>Driver's Signature:....................................</b></p>
    
</div>

<div style={{width:"49%"}}>

<p><b>Receiver:....................................</b></p>
<p><b>signature:....................................</b></p>
<p><b>Date:....................................</b></p>
<textarea rows={6} style={{width:"100%", }}/>

</div>

   </div>

    </div>
    </div>
  );
}


const loadorder=()=>{
  var chosencustomer = customer_.filter(bug=>bug.businessname===props.chosen.customer)


  return(
    <div>
    <ReactToPrint
                 pageStyle='@page { size: A4; margin: 0mm; } @media print { body { scale:1; font-size:8pt; font-family:georgia, times, serif; } }'
               
               trigger={()=><Button>Print Load Order</Button>}
                content ={()=>componentRefload.current}
                />
        <div style={{margin:"20px", marginTop:"-15px"}} ref={componentRefload}>
        <div align="center">
    <br/>
        <div style={{border:"solid", borderWidth:"1px", borderColor:"grey"}}>
          <p align="center">
          <image src={Logo}  style={{width:"70px", }}/> <br/>

          <b>EMBETT AGRO GHANA LTD</b> <br/>
          <b>GOODS LOAD ORDER</b>
            </p>
        </div>
          
        <p> 
        <small>P.O. BOX HS8504 AHINSAN KUMASI</small><br/> 
        <small>PLOT 38 BLOCK 38, AYIGYA ESTATE</small> <br/>
        <small>GPS : AK-388-7405</small> <br/>
        <small>TEL : +233 205645027 0R +223 244635134</small> <br/>
        </p>
           </div>
     
    
    
         
    
         <div style={{display:"flex", width:"100%"}}>
    
         <div style={{width:"49%"}}>
    <p> <b> Despatch To : </b>{props.chosen.customer} </p>
    <p> <b> Transporter: </b>{props.chosen.driver} </p>
    <p> <b> Vehicle NO. : </b>{props.chosen.vehicle} </p>
    </div>
    
    <div style={{width:"49%"}}>
    
    <p> <b> Driver's contact : </b>{props.chosen.drivercontact} </p>
    <p> <b> Date : </b>{props.chosen.date} </p>
    
    </div>
    
        </div>
    
    
        <TableContainer >
          <Table sx={{ minWidth: 700 }} aria-label="spanning table">
         
            <TableHead>
    
              <TableRow>
                <TableCell>Quantity</TableCell>
                <TableCell align="left">Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.chosen.purchase.map((row) => (
                <TableRow key={row.desc}>
                  <TableCell>{row.qty}</TableCell>
                  <TableCell align="left">{row.product}</TableCell>
                </TableRow>
              ))}
              
            </TableBody>
          </Table>
        </TableContainer>
    
        
        
        <div style={{display:"flex", width:"100%"}}>
    
        <div style={{width:"49%"}}>
        <p><b>Date Issued:....................................</b></p>
        <p><b>Issued by:....................................</b></p>
        <p><b>Despatched From:....................................</b></p>
        
    </div>
    
    <div style={{width:"49%"}}>
    
    <p><b>Received:....................................</b></p>
    <p><b>In good condotion</b></p>
    <p><b>Date:....................................</b></p>
    
    
    </div>
    
       </div>
    
        </div>
        </div>
      );

}




const recovredcontract=()=>{
  
  const recovered = () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/requisition/editrequisition/",
            {
                _id: props.chosen.id,
                status: "Recovered",
                approvepaymentdate: date,
            
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log(res)
                    dispatch(getcontract({

                      data: res.data

                  })) 
                  handleClose()
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            console.log(err)
            setloading(false)
           
}
    }

    doer()

   

  

}

    return(
         
         
      <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          

         <p>Are you sure you want to <b>Recover</b> this contract?</p>


<div style={{marginTop:2, textAlign:"center"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
              :<Button  variant="outlined" size={"large"} onClick={recovered}>Recovered Contract</Button>
}
              </div>
          
        </Box>

         
    )
}


const approvecontract=()=>{
  
  const approve = () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/requisition/editrequisition/",
            {
                _id: props.chosen.id,
                status: "Approved",
                approvecontractdate: date,
            
            }).then(res => {

              console.log("res")
              console.log(res)

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log(res)
                    dispatch(getcontract({

                      data: res.data

                  })) 
                  handleClose()
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            console.log(err)
            setloading(false)
           
}
    }

    doer()

   

  

}

    return(
         
         
      <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          

         <p>Are you sure you want to <b>Approve</b> this contract?</p>


<div style={{marginTop:2, textAlign:"center"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
              :<Button  variant="outlined" size={"large"} onClick={approve}>Approve Contract</Button>
}
              </div>
          
        </Box>

         
    )
}


const closecontract=()=>{ 
 
  
  const close = () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/requisition/editrequisition/",
            {
                _id: props.chosen.id,
                status: "Closed",
                closecontractdate:date
            
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log(res)
                    dispatch(getcontract({

                      data: res.data

                  })) 
                  handleClose()
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            console.log(err)
            setloading(false)
           
}
    }

    doer()

   

  

}

    return(
         
         
      <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          

         <p>Are you sure you want to <b>Close</b> this contract?</p>


<div style={{marginTop:2, textAlign:"center"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
              :<Button  variant="outlined" size={"large"} onClick={close}>close Contract</Button>
}
              </div>
          
        </Box>

         
    )
} 



const distributecontract=()=>{
  
  
  
  const distribute = () =>{
    setloading(true)
   
      const doer = async () => {
        
        try{

        await axios.post("https://server.agrotraciserp.com/api/requisition/editrequisition/",
            {
                _id: props.chosen.id,
                status: "Distributed",
                datedistributed: date,
            
            }).then(res => {

                if (res.status === 200) {
                
                    setloading(false) 
                    console.log(res)
                    dispatch(getcontract({

                      data: res.data

                  })) 
                  handleClose()
                    
                } else {
                    setloading(false)
                  
                }

            })
          }catch(err){
            console.log(err)
            setloading(false)
           
}
    }

    doer()

   

  

}

    return(
         
         
      <Box
      component="form"
      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
          

         <p>Are you sure you want to <b>Distribute</b> this contract?</p>


<div style={{marginTop:2, textAlign:"center"}}>    
             { loading? <Button  variant="outlined" startIcon={<Progress />} disabled onClick={handleOpen}>Loading...</Button>
              :<Button  variant="outlined" size={"large"} onClick={distribute}>Distribute Contract</Button>
}
              </div>
          
        </Box>

         
    )

}


return (
    <div>
     
     
 
<Dialog fullWidth minWidth="lg" onClose={handleOpen} aria-labelledby="customized-dialog-title" open={open}>
<DialogTitle id="customized-dialog-title" onClose={handleClose} >
           {props.name}
     
       <IconButton onClick={handleClose} style={{float:"right"}}><CloseIcon/></IconButton>
      
   </DialogTitle>
   <Divider/>
 <DialogContent>

 {props.name==="Product" && product()}
 {props.name==="Farmer" && farmer()}
 {props.name==="Customer" && customer()}
 {props.name==="Hauller" && hauller()}
 {props.name==="Staff" && staff()}
 {props.name==="Warehouse" && warehouse()}
 {props.name==="Processing Center" && processing()}
 {/* {props.name==="Service" && service()} */}
 {props.name==="Services" && service()}
 {props.name==="Issue Invoice" && invoice()}
 {props.name==="Issue Load Order" && loadorder()}
 {props.name==="Approve Order" && approve()}
 {props.name==="Purchase Order" && purchaseorder()}
 {props.name==="Waybill" && waybill()}
 {props.name==="Supply" && supply()}
 {props.name==="Approve Recovery / Payment" && recovredcontract()}
 {props.name==="Approve Contract" && approvecontract()}
 {props.name==="Close Contract" && closecontract()}
 {props.name==="Distribute Input" && distributecontract()}


 </DialogContent>
 {/* <Divider/> */}
  
</Dialog>


</div>



  );
}
